import classNames from "classnames";
import { FieldState } from "formstate";
import { observer } from "mobx-react";
import React, { useState } from "react";
import { TextButton } from "../../../../textButton/textButton";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { useStore } from "../../../../../models";
import settingsStyles from "../../../../../styles/settings.css";
import { TagTagGroupPicker } from "../../../../forms/tagPicker/tagtagGroupPicker";
import { TagsList } from "../../../tags/tagName/tagsList";

interface Props {
  tagIds: FieldState<string[]>;
  tagGroupIds: FieldState<string[]>;
  onTagDelete(tagId: string): void;
  onTagGroupDelete(tagGroupId: string): void;
}

export const TagsTagGroupsInput = observer(
  ({ tagIds, tagGroupIds, onTagDelete, onTagGroupDelete }: Props) => {
    const { tagsStore, tagGroupsStore } = useStore();
    const [isPicking, setIsPicking] = useState(false);

    const tags = tagsStore.getFromIds(tagIds.$);
    const tagGroups = tagGroupIds ? tagGroupsStore.getFromIds(tagGroupIds.$) : [];
    const pickableTags = tagsStore.getWithoutIds(tagIds.$);
    const pickableTagGroups = tagGroupIds ? tagGroupsStore.getWithoutIds(tagGroupIds.$) : [];

    const renderInput = () =>
      isPicking ? (
        <TagTagGroupPicker
          onOutsideClick={() => setIsPicking(false)}
          className={classNames(
            settingsStyles["list-margin"],
            settingsStyles["input-width-bigger"]
          )}
          initialIsOpen
          onTagPicked={(tag) => {
            tagIds.reset([...tagIds.$, tag.id]);
            setIsPicking(false);
          }}
          onTagGroupPicked={(group) => {
            tagGroupIds.reset([...tagGroupIds.$, group.id]);
            setIsPicking(false);
          }}
          providedTags={pickableTags}
          providedTagGroups={pickableTagGroups}
          hasError={tagIds.hasError}
          onStateChange={(_, state) => (!state.isOpen ? setIsPicking(false) : undefined)}
          onTypePickerClosed={() => setIsPicking(false)}
        />
      ) : (
        <TextButton
          text={"+ " + intl.formatMessage("settings.advisers.edit.skills.add")}
          className={settingsStyles["list-margin"]}
          onClick={() => setIsPicking(true)}
        />
      );

    return (
      <div>
        <TagsList
          tags={tags}
          tagGroups={tagGroups}
          onTagDelete={onTagDelete}
          onTagGroupDelete={onTagGroupDelete}
        />
        {!!pickableTags.length && renderInput()}
      </div>
    );
  }
);
